import { Component, ChangeDetectionStrategy, Output, EventEmitter } from "@angular/core";

@Component({
	selector: "ic-terms-conditions-text",
	templateUrl: "terms-conditions-text.component.html",
	styleUrls: ["terms-conditions-text.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TermsConditionsTextComponent {
	@Output() openBrowser = new EventEmitter<string>();

	openPrivacyPolicy(event: Event) {
		event.preventDefault();
		this.openBrowser.next("https://into.care/privacy");
	}
}
